<template>
  <div id="indexlayout">
    <layout-index-left-jx v-if="left === 'jx'" />
    <layout-index-left v-else />
    <div id="indexlayout-right" :class="{ 'fiexd-header': siteFiexdHeader }">
      <layout-index-right-top />
      <div class="indexlayout-right-main">
        <app-main />

        <!-- <theme-picker v-if="isAdmin"></theme-picker> -->
      </div>
    </div>
  </div>
</template>
<script>
import AppMain from '../components/AppMain'
import LayoutIndexLeft from './LayoutIndexLeft'
import LayoutIndexLeftJx from './LayoutIndexLeftJx'
import LayoutIndexRightTop from './LayoutIndexRightTop'
import { getLeft } from '../../service/page'
// import ThemePicker from '../components/ThemePicker'

export default {
  name: 'LayoutIndex',
  components: {
    AppMain,
    LayoutIndexLeft,
    LayoutIndexLeftJx,
    LayoutIndexRightTop
    // ThemePicker
  },
  mounted() {
    if (this.companyId) {
      this.getOkq(this.companyId)
    }
  },
  computed: {
    isAdmin() {
      let role = this.$store.getters.role
      return role && role.id === 1
    },
    left() {
      const companyId = this.$store.getters.companyId
      return getLeft(companyId)
    }
  },
  methods: {
    async getOkq(id) {
      try {
        await this.$store.dispatch('user/setOkq', id)
      } catch (e) {
        this.$message.error('获取 孢子仪/鼠害 设备信息错误.')
      }
    }
  },
  watch: {
    companyId(id) {
      this.getOkq(id)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/variables.scss';
#indexlayout {
  display: flex;
  height: 100vh;
  overflow: hidden;
}
#indexlayout-right {
  position: relative;
  flex: 1;
  overflow: auto;
  background-color: $mainBgColor;
  &.fiexd-header {
    display: flex;
    flex-direction: column;
    .indexlayout-right-main {
      flex: 1;
      overflow: auto;
    }
  }
}
</style>
